/** TC inline lander editor; global tracker record, scoped by the bank write policy. For Media Devoted | Created By Ciro Autiero */
import { Button } from '@/components/ui/layout/Button';
import { Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from '@/components/ui/layout/Drawer';
import type { PathLanderEditDialogProps } from '@/features/flow-optimizer/tabs/standard/v2/paths/path-items/lander-editor';
import { TcLanderFields } from '@/features/flow-optimizer/tracker-entities/tres-commas/TcLanderFields';
import { useTcLanderEditor } from '@/features/flow-optimizer/tracker-entities/tres-commas/useTcLanderEditor';
export function TcLanderEditor(props: PathLanderEditDialogProps) {
  const state = useTcLanderEditor(props);
  return <Drawer open={props.open} onOpenChange={props.onOpenChange}>
    <DrawerContent variant="center" width="w-[min(520px,94vw)]" className="max-h-[90vh]">
      <DrawerHeader><DrawerTitle>Edit Tres Commas lander</DrawerTitle></DrawerHeader>
      <DrawerBody className="max-h-[65vh] overflow-y-auto space-y-3">
        <p className="text-xs text-muted-foreground">Changes apply everywhere this lander is used.</p>
        {state.error ? <p role="alert">{state.error}</p> : state.values ?
          <TcLanderFields values={state.values} patch={state.patch} disabled={state.saving} /> : <p>Loading from Tres Commas…</p>}
      </DrawerBody>
      <DrawerFooter><Button variant="outline" onClick={() => props.onOpenChange(false)}>Cancel</Button>
        <Button disabled={!state.values || state.saving || Boolean(state.error)} onClick={() => void state.save()}>
          {state.saving ? 'Saving…' : 'Save'}</Button></DrawerFooter>
    </DrawerContent>
  </Drawer>;
}
